import { TrendingUp } from '@mui/icons-material';
import { Stack, styled, Typography } from '@mui/material';

export const StatusContainer = styled(Stack)(({ theme }) => ({
  height: theme.spacing(3.5),
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  background: theme.palette.primary.light,
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.5, 0.5),
  overflow: 'hidden',
}));

export const TrendingIcon = styled(TrendingUp)(({ theme }) => ({
  // @ts-ignore
  color: theme.palette.primary.darker,
}));

export const StatusText = styled(Typography)(({ theme }) => ({
  // @ts-ignore
  color: theme.palette.primary.darker,
  fontSize: 12,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
